module.exports = __webpack_public_path__ + "static/media/camoflix-screenshot.9a396380.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/camoflix-screenshot.png
// module id = 58
// module chunks = 0